import request from '@shared/utils/request'

export function configAdd(data) {
  return request({
    url: '/sys-config/update',
    method: 'post',
    data
  })
}
export function configGet(params) {
  // 这个接口可能后台没上 屏蔽401和错误提示
  return request({
    url: '/sys-config/get',
    method: 'get',
    params,
    hide401: true,
    hideErrorMsg: true
  })
}




export function getConfigStyle(params) {
  return request({
    url: '/sys-config/getConfigStyle',
    method: 'post',
    params
  })
}